// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__35vyB","col":"CardReaderDesc_col__BKK_c","label":"CardReaderDesc_label__3HQnF"};